module.exports = __webpack_public_path__ + "img/Chrome.7d05cc95.png";